<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">数据统计</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>平台：</label>
          <el-select v-model="platformType" placeholder="Select" style="width: 6.4em" @change="changeChannelList">
            <el-option v-for="item in platformTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item" v-show="iosSourceShowDiv">
          <label>来源类型：</label>
          <el-select v-model="source" placeholder="Select" style="width: 6.4em" @change="changeIosSourceList">
            <el-option v-for="item in iosSourceArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>渠道：</label>
          <el-select v-model="channel" placeholder="Select" style="width: 10em">
            <el-option v-for="item in channelArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <el-checkbox v-model="tjChannelNow" style="margin-left: 8px;">实时统计</el-checkbox>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :table2Ref="$refs.multipleTable2Ref" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            v-loading="listLoading"
            @cell-click="toggleSelection"
        >
          <el-table-column width="105" property="countDay" label="日期" v-if="checkColList.indexOf('日期') > -1"/>
          <el-table-column property="jihuoNum" label="激活数(人)" v-if="checkColList.indexOf('激活数(人)') > -1"/>
          <el-table-column property="phoneNum" label="手机注册(人)" v-if="checkColList.indexOf('手机注册(人)') > -1"/>
          <el-table-column property="enterNum" label="进入用户(人)" v-if="checkColList.indexOf('进入用户(人)') > -1"/>
          <el-table-column property="allEnterNum" label="正式用户(人)" v-if="checkColList.indexOf('正式用户(人)') > -1"/>
          <el-table-column property="payEnterNum" label="付费进入(人)" v-if="checkColList.indexOf('付费进入(人)') > -1"/>
          <el-table-column property="regBaoNum" label="保证金+认证费(人)" v-if="checkColList.indexOf('保证金+认证费(人)') > -1"/>
          <el-table-column property="regNum" label="提交证件+认证费(人)" v-if="checkColList.indexOf('提交证件+认证费(人)') > -1"/>
          <el-table-column property="codeNum" label="提交证件+邀请码(人)" v-if="checkColList.indexOf('提交证件+邀请码(人)') > -1"/>
          <el-table-column property="authSubmitNum" label="身份证提交数(人)" v-if="checkColList.indexOf('身份证提交数(人)') > -1"/>
          <el-table-column property="authNum" label="身份认证成功数(人)" v-if="checkColList.indexOf('身份认证成功数(人)') > -1"/>
          <el-table-column property="resumeNum" label="信息通过审核数(人)" v-if="checkColList.indexOf('信息通过审核数(人)') > -1"/>
          <el-table-column property="regMoney" label="认证费金额(元)" v-if="checkColList.indexOf('认证费金额(元)') > -1"/>
          <el-table-column property="goldMoney" label="购买金币金额(元)" v-if="checkColList.indexOf('购买金币金额(元)') > -1"/>
          <el-table-column property="vipNum" label="会员开通数(人)" v-if="checkColList.indexOf('会员开通数(人)') > -1"/>
          <el-table-column property="vipMoney" label="VIP(元)" v-if="checkColList.indexOf('VIP(元)') > -1"/>
          <el-table-column property="effectiveMoney" label="有效收入(元)" v-if="checkColList.indexOf('有效收入(元)') > -1"/>
          <el-table-column property="baoMoney" label="保证金(元)" v-if="checkColList.indexOf('保证金(元)') > -1"/>
          <el-table-column property="marriageMoney" label="SVIP(元)" v-if="checkColList.indexOf('SVIP(元)') > -1"/>
          <el-table-column property="allMoney" label="营业收入(元)" v-if="checkColList.indexOf('营业收入(元)') > -1"/>
          <el-table-column property="returnBao" label="保证金返还(元)" v-if="checkColList.indexOf('保证金返还(元)') > -1"/>
          <el-table-column property="gainMoney" label="净收入(元)" v-if="checkColList.indexOf('净收入(元)') > -1"/>
          <el-table-column property="arpu" label="ARPU" v-if="checkColList.indexOf('ARPU') > -1"/>
          <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor"/>

        </el-table>
        
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
      <div style="display: flex; margin-top: 20px; justify-content: space-between; align-items: flex-start" v-show="dataSummaryShowDiv">
          <el-table
              ref="multipleTable2Ref"
              :data="dataSummary"
              style="width: 100%;"
              border
              v-loading="listLoading"
          >
            <el-table-column width="105" property="" label="汇总"/>
            <el-table-column property="jihuoNum" label="激活数(人)" v-if="checkColList.indexOf('激活数(人)') > -1"/>
            <el-table-column property="phoneNum" label="手机注册(人)" v-if="checkColList.indexOf('手机注册(人)') > -1"/>
            <el-table-column property="enterNum" label="进入用户(人)" v-if="checkColList.indexOf('进入用户(人)') > -1"/>
            <el-table-column property="allEnterNum" label="正式用户(人)" v-if="checkColList.indexOf('正式用户(人)') > -1"/>
            <el-table-column property="payEnterNum" label="付费进入(人)" v-if="checkColList.indexOf('付费进入(人)') > -1"/>
            <el-table-column property="regBaoNum" label="保证金+认证费(人)" v-if="checkColList.indexOf('保证金+认证费(人)') > -1"/>
            <el-table-column property="regNum" label="提交证件+认证费(人)" v-if="checkColList.indexOf('提交证件+认证费(人)') > -1"/>
            <el-table-column property="codeNum" label="提交证件+邀请码(人)" v-if="checkColList.indexOf('提交证件+邀请码(人)') > -1"/>
            <el-table-column property="authSubmitNum" label="身份证提交数(人)" v-if="checkColList.indexOf('身份证提交数(人)') > -1"/>
            <el-table-column property="authNum" label="身份认证成功数(人)" v-if="checkColList.indexOf('身份认证成功数(人)') > -1"/>
            <el-table-column property="resumeNum" label="信息通过审核数(人)" v-if="checkColList.indexOf('信息通过审核数(人)') > -1"/>
            <el-table-column property="regMoney" label="认证费金额(元)" v-if="checkColList.indexOf('认证费金额(元)') > -1"/>
            <el-table-column property="goldMoney" label="购买金币金额(元)" v-if="checkColList.indexOf('购买金币金额(元)') > -1"/>
            <el-table-column property="vipNum" label="会员开通数(人)" v-if="checkColList.indexOf('会员开通数(人)') > -1"/>
            <el-table-column property="vipMoney" label="VIP(元)" v-if="checkColList.indexOf('VIP(元)') > -1"/>
            <el-table-column property="effectiveMoney" label="有效收入(元)" v-if="checkColList.indexOf('有效收入(元)') > -1"/>
            <el-table-column property="baoMoney" label="保证金(元)" v-if="checkColList.indexOf('保证金(元)') > -1"/>
            <el-table-column property="marriageMoney" label="SVIP(元)" v-if="checkColList.indexOf('SVIP(元)') > -1"/>
            <el-table-column property="allMoney" label="营业收入(元)" v-if="checkColList.indexOf('营业收入(元)') > -1"/>
            <el-table-column property="returnBao" label="保证金返还(元)" v-if="checkColList.indexOf('保证金返还(元)') > -1"/>
            <el-table-column property="gainMoney" label="净收入(元)" v-if="checkColList.indexOf('净收入(元)') > -1"/>
            <el-table-column property="arpu" label="ARPU" v-if="checkColList.indexOf('ARPU') > -1"/>
          </el-table>
        </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import BtnGroup from '../../components/BtnGroup'
import {getTjChannelPageList, tjChannelList, getTjChannelSummary, getTjChannelNow} from '../../api/url'
import { getFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import addRemarkDialog from "@/views/data/components/TjChannelRemarkDialog";


export default {
  name: "DataTjChannel",
  components: { BtnGroup, DatePickerRange },
  data() {
    return {

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,

      platformTypeArray: [
        {label: '不限', value: -1},
        {label: '安卓', value: 1},
        {label: 'IOS', value: 2},
        {label: '鸿蒙', value: 4},
      ],
      platformType: -1,

      iosSourceArray: [
        {label: '不限', value: 0},
        {label: '自然来源', value: 1},
        {label: 'ASA来源', value: 2},
      ],
      source: 0,
      iosSourceShowDiv: false,

      channelArray: [
        {label: '不限', value: '-1'},
      ],
      ios1List: [],
      ios2List: [],
      otherChannelList: [],
      channel: '-1',


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //刷新组
      colList: ['日期', '激活数(人)', '手机注册(人)', '进入用户(人)', '正式用户(人)', '付费进入(人)', '保证金+认证费(人)', '提交证件+认证费(人)', 
        '提交证件+邀请码(人)', '身份证提交数(人)', '身份认证成功数(人)', '信息通过审核数(人)', '认证费金额(元)', '购买金币金额(元)', '会员开通数(人)', 
        'VIP(元)', '有效收入(元)', '保证金(元)', 'SVIP(元)', '营业收入(元)', '保证金返还(元)', '净收入(元)', 'ARPU', '备注'
      ],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      tjChannelNow: false,
      dataSummaryShowDiv: true,

      dataSummary: [],

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
    },

    getCheck(val) {
      this.isChecked = val
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      this.platformType = -1;
      this.channel = '-1';
      this.source = 0;
      this.tjChannelNow = false;
      this.iosSourceShowDiv = false;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    changeChannelList() {
      this.channelArray = [
        {label: '不限', value: '-1'},
      ];
      this.channel = '-1'
      this.source = 0
      if(this.platformType == 2) {
        this.iosSourceShowDiv = true;
      } else {
        this.iosSourceShowDiv = false;
      }
      
      this.otherChannelList = [];
      this.ios1List = [];
      this.ios2List = [];
      this.getChannelList();
    },

    changeIosSourceList() {
      this.channelArray = [
        {label: '不限', value: '-1'},
      ]
      this.channel = '-1'
      if (this.source == 0) {
        this.channelArray = [...this.channelArray, ...this.otherChannelList, ...this.ios1List, ...this.ios2List]
      } else if (this.source == 1) {
        this.channelArray = [...this.channelArray, ...this.ios1List]
      } else if (this.source == 2) {
        this.channelArray = [...this.channelArray, ...this.ios2List]
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        if(this.tjChannelNow) {
          this.dataSummaryShowDiv = false;
          this.sendTjChannelNowReq(this.getPageParam(this.currentPage));
        } else {
          this.dataSummaryShowDiv = true;
          if(reset) {
            this.currentPage = 1;
            this.getSummarydata()
          }
          this.sendPageReq(this.getPageParam(this.currentPage));
        }
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['platformType'] = this.platformType;
      param['source'] = this.source;
      param['channel'] = this.channel;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getTjChannelPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.forEach(item => {
            item.payEnterNum = item.regBaoNum + item.regNum
            item.arpu = 0;
            if(item.phoneNum) {
              item.arpu = Math.round((item.allMoney / item.phoneNum)*100) / 100
            }
          })
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      }).catch((response) => {
        this.searchLoading = false;
        this.listLoading = false;
      })
    },

    // 发送实时统计请求
    sendTjChannelNowReq(param) {
      getFormData(getTjChannelNow, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.forEach(item => {
            item.payEnterNum = item.regBaoNum + item.regNum
            item.arpu = 0;
            if(item.phoneNum) {
              item.arpu = Math.round((item.allMoney / item.phoneNum)*100) / 100
            }
          })
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      }).catch((response) => {
        this.searchLoading = false;
        this.listLoading = false;
      })
    },

    getChannelList() {
      let param = {};
      param['platformType'] = this.platformType;
      getFormData(tjChannelList, param).then((data)=>{
        let {msg, code} = data;
        if(code == 200) {
          let dataList = data.data;
          dataList.forEach(item=>{
            if(item.channel != '-1') {
              let obj = {}
              obj.label = item.channel
              obj.value = item.channel
              if(this.platformType == 2) {
                if(item.source == 1) {
                  this.ios1List.push(obj)
                } else if(item.source == 2){
                  this.ios2List.push(obj)
                } else {
                  this.otherChannelList.push(obj)
                }
              } else {
                this.channelArray.push(obj)
              }
            }
          })
          this.channelArray = [...this.channelArray, ...this.otherChannelList, ...this.ios1List, ...this.ios2List]
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    getSummarydata() {
      let param = {};
      param['sex'] = this.sex;
      param['platformType'] = this.platformType;
      param['source'] = this.source;
      param['channel'] = this.channel;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      getFormData(getTjChannelSummary, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          data.data.payEnterNum = data.data.regBaoNum + data.data.regNum
          data.data.arpu = 0;
          if(data.data.phoneNum) {
            data.data.arpu = Math.round((data.data.allMoney / data.data.phoneNum)*100) / 100
          }
          this.dataSummary = []
          this.dataSummary.push(data.data)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.label == '备注') {
        Dialog.open({
          title: '添加备注',
          component: addRemarkDialog,
          data: {
            row: row,
            width: '600px'
          }
        })
      }
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getChannelList();
    this.getSummarydata();
  }
}
</script>

<style scoped>
.img-item {
  width: 40px;
  height: 40px;
}
.img-more {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 8px;
  color: #c0c4cc;
  background-color: #f5f7fa;
}
</style>
